import React, { useState, useEffect } from 'react'
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { Grommet, Box, Image, ResponsiveContext, Text } from 'grommet'
import { Slack } from 'grommet-icons'
import { theme } from '../../branding'
import BusOperations from '../BusOperations'
import Quotes from '../Quotes'
import qlikLogo from '../../Qlik-Logo_RGB.png'
import Header from '../../components/Header'
import BugfixOperations from '../BugfixOperations'
import QueriesOperations from '../QueriesOperations'
import Repositories from '../Repositories'
import { API } from '../../libs/amplifyAPI'

const Main = () => {
  const [status, setStatus] = useState({
    query: false,
    bugfix: false, 
    ui: false
  })

  useEffect(() => {
    API.get('Status', 'status')
    .then(data => {
      setStatus(data)
    })
    .catch(err => {
      console.log(err)
    })
  }, [])

  const router = createBrowserRouter([
    {
      path: '/',
      element: <BusOperations />,
    },
    {
      path: '/bugfix',
      element: <BugfixOperations />,
    },
    {
      path: '/queries',
      element: <QueriesOperations />,
    },
    {
      path: '/quotes',
      element: <Quotes />,
    },
    {
      path: '/repositories',
      element: <Repositories />,
    }
  ]);

  return (
    <Grommet theme={theme}>
      <ResponsiveContext.Consumer>
        {size => (
          <Box>
            <Box pad='medium' justify='end'>
              <Header size={size} status={status} />
            </Box>
            <RouterProvider router={router} />
            <Box pad='small' height='xsmall'><Image src={qlikLogo} fit='contain'/></Box>
            <Box direction='row-responsive' align='center' justify='center' gap='small' pad='small'><Slack color='plain' /><Text size='xlarge' weight='bold'>Globalization</Text></Box>
          </Box>
        )}
      </ResponsiveContext.Consumer>
    </Grommet>
  )
}

export default Main
